<!--
 * @Description: PC 端页面header
 * @Date: 2021-10-31 15:59:54
 * @LastEditTime: 2022-01-26 15:34:57
-->
<template lang="pug">
  div.player-title-container
    div.left-container
      img.logo.logo1(:src="logo1" @click="toWebHomePage()")
      //- img.logo(:src="logo2")
      img.logo(:src="logoImg" v-if='logoImg')
      div.player-title
        span {{ roomName }}

      //- div.view-count(title="观看数")
      //-   svg-icon(icon-name="view-count")
      //-   span {{viewSum}}

    div.right-container
      //- comp-language(pageName="player")
      comp-exit
      comp-user-info
</template>

<script>
import compLanguage from './comp-language';
import compUserInfo from './comp-user-info';
import compExit from './comp-exit';
import avatar from '@/assets/img/avatar.png';
import logo1 from '@/assets/img/logo1.png';
import logo2 from '@/assets/img/logo2.png';
import { mapState } from 'vuex';
export default {
  name: 'compHeader',
  data() {
    return {
      logo1,
      logo2,
      avatar,
    };
  },
  components: {
    compLanguage,
    compUserInfo,
    compExit,
  },
  computed: {
    ...mapState({
      roomName: state => state.player.roomName,
      userInfo: state => state.player.userInfo,
      liveInfo: state => state.player.liveInfo,
      viewSum: state => state.player.viewSum || '0',
      logoImg: (state) => {
        if (state?.player?.liveInfo?.logoImages && state.player.liveInfo.logoImages.length > 0) {
          return state.player.liveInfo.logoImages[0].url
        }
        return ''
      },
    }),
  },
  methods: {
    toWebHomePage: () => {
      window.location.href = 'https://www.xkb.com.cn';
    },
  },
};
</script>

<style lang="stylus" scoped>
.player-title-container
  width 100%
  height 100%
  position relative
  display flex
  justify-content space-between
  align-items center

  max-width 1400px
  margin 0 auto

  // padding 0 16px 0 20px
  .left-container
    height 100%
    display flex
    align-items center
    flex 1
    padding 0 16px 0 20px
    .logo
      // height 20px
      height 40px
      margin-right 20px
      max-width 260px

    .logo1
      height: 40px
      cursor pointer
    .player-title
      font-weight medium
      text-align left
      width 400px
      overflow hidden
      text-overflow ellipsis
      white-space nowrap
      flex 1
      padding-right 30px
    .view-count
      svg
        color #f00
        font-size 12px
        margin-right 5px

  .right-container
    height 100%
    display flex
    align-items center
    // display none
    width 38%
    min-width 300px
    max-width 550px
    justify-content flex-end
    & > *
      display none
    & > :not(:first-child)
      margin-left 16px
</style>
